export default "__VITE_ASSET__CWql5iwc__";